var _defs, _g, _path, _path2, _g2, _g3, _g4, _path3, _path4, _g5, _g6, _path5, _path6, _path7, _path8, _path9, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath);}.cls-2{fill:none;}.cls-2,.cls-3,.cls-4{stroke-width:0px;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath-4);}.cls-7{clip-path:url(#clippath-3);}.cls-8{clip-path:url(#clippath-2);}.cls-9{clip-path:url(#clippath-6);}.cls-10{clip-path:url(#clippath-5);}.cls-3{fill-rule:evenodd;}.cls-3,.cls-4{fill:#4924ce;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 83.77,
    y: 12.98,
    width: 25.13,
    height: 32.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.52,
    y: 17.41,
    width: 9.84,
    height: 9.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.7,
    y: 42.79,
    width: 6.2,
    height: 13.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.97,
    y: 42.79,
    width: 5.91,
    height: 13.78
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 85.25,
    y: 53.83,
    width: 23.55,
    height: 19.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 97.88,
    y: 62.11,
    width: 23.04,
    height: 19.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.44,
    y: 33.72,
    width: 25.1,
    height: 25.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m107.7,16.59h-5.41l-2.86-2.84s-.09-.08-.14-.12c-.45-.37-1.16-.64-1.71-.64h-12.39c-.78,0-1.42.64-1.42,1.42v26.45c0,.78.64,1.42,1.42,1.42h1.62v2.18c0,.78.64,1.42,1.42,1.42h19.47c.78,0,1.42-.64,1.42-1.42v-26.45c0-.78-.64-1.41-1.42-1.41Zm-8.7-1.64l5.1,5.06h-4.83c-.15,0-.27-.12-.27-.27v-4.79h0Zm-14.08,25.91V14.41c0-.15.12-.27.27-.27h12.39c.09,0,.18.01.29.04-.01.07-.01.15-.01.22v5.33c0,.78.64,1.42,1.42,1.42h5.39c.08,0,.16,0,.22-.02.03.1.04.2.04.29v19.42c0,.15-.12.27-.27.27h-19.46c-.15,0-.27-.12-.27-.27Zm23.04,3.6c0,.15-.12.27-.27.27h-19.47c-.15,0-.27-.12-.27-.27v-2.18h16.69c.78,0,1.42-.64,1.42-1.42v-19.42c0-.56-.27-1.25-.64-1.7-.03-.05-.07-.09-.13-.14l-1.86-1.85h4.25c.15,0,.27.12.27.27v26.45Zm-6.27-18.99h-13.55c-.27,0-.49-.23-.49-.49s.23-.49.49-.49h13.55c.27,0,.49.22.49.49s-.22.49-.49.49Zm0,3.6h-13.55c-.27,0-.49-.22-.49-.49s.23-.49.49-.49h13.55c.27,0,.49.22.49.49s-.22.49-.49.49Zm0,3.6h-13.55c-.27,0-.49-.23-.49-.49s.23-.49.49-.49h13.55c.27,0,.49.22.49.49s-.22.49-.49.49Zm-7.74,3.6h-5.81c-.27,0-.49-.22-.49-.49s.23-.49.49-.49h5.81c.27,0,.49.22.49.49s-.22.49-.49.49Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m34.45,29.76h20.26c5.57,0,10.62,2.28,14.29,5.94,3.67,3.67,5.94,8.73,5.94,14.29s-2.28,10.63-5.94,14.3c-3.67,3.67-8.73,5.94-14.29,5.94h-2.21l-11.23,10.47c-1.01.94-2.61.88-3.55-.13-.45-.48-.68-1.1-.68-1.71v-8.63h-2.58c-5.57,0-10.62-2.28-14.29-5.94s-5.94-8.73-5.94-14.3,2.28-10.62,5.94-14.29c3.67-3.67,8.73-5.94,14.29-5.94Zm20.26,5.04h-20.26c-4.17,0-7.97,1.71-10.73,4.47s-4.47,6.56-4.47,10.73,1.71,7.98,4.47,10.74c2.76,2.75,6.56,4.47,10.73,4.47h5.1c1.39,0,2.52,1.12,2.52,2.51v5.37l7.61-7.1c.46-.49,1.11-.79,1.83-.79h3.2c4.17,0,7.98-1.71,10.73-4.47s4.47-6.56,4.47-10.74-1.71-7.98-4.47-10.73c-2.75-2.76-6.56-4.47-10.73-4.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m42.87,22.15h3.42v10.39h-3.42v-10.39Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m44.58,17.43c2.48,0,4.48,2.01,4.48,4.48s-2.01,4.49-4.48,4.49-4.49-2.01-4.49-4.49,2.01-4.48,4.49-4.48Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m15.68,55.99c-3.31,0-5.98-2.68-5.98-5.99s2.68-5.98,5.98-5.98v11.97Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m73.57,55.99c3.31,0,5.98-2.68,5.98-5.99s-2.68-5.98-5.98-5.98v11.97Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m36.38,42.84c1.46,0,2.66,1.2,2.66,2.66v8.05c0,1.47-1.2,2.66-2.66,2.66s-2.66-1.19-2.66-2.66v-8.05c0-1.46,1.2-2.66,2.66-2.66Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.78,42.84c1.46,0,2.66,1.2,2.66,2.66v8.05c0,1.47-1.2,2.66-2.66,2.66s-2.66-1.19-2.66-2.66v-8.05c0-1.46,1.2-2.66,2.66-2.66Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m105.12,68.28c1.57,0,2.84-1.27,2.84-2.84v-8.76c0-1.57-1.28-2.84-2.84-2.84h-17.02c-1.57,0-2.84,1.28-2.84,2.84v8.75c0,1.37.98,2.52,2.28,2.79v3.51c0,.28.16.54.4.67.11.06.23.09.36.09.15,0,.29-.04.42-.13l6.23-4.1h10.17Zm-16.82-1.53s-.06,0-.1,0c-.03,0-.06,0-.1,0-.73,0-1.32-.59-1.32-1.32v-8.75c0-.73.59-1.32,1.32-1.32h17.02c.73,0,1.32.59,1.32,1.32v8.75c0,.73-.59,1.32-1.32,1.32h-10.41s-.03,0-.04,0c-.03,0-.07,0-.1,0-.03,0-.05.02-.07.02-.02,0-.05.01-.07.02-.04.02-.07.03-.09.05-.02,0-.03.02-.03.02h0s-5.22,3.44-5.22,3.44v-2.8c0-.43-.35-.77-.77-.77Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m118.04,62.95h-8.52c-.42,0-.76.34-.76.76s.34.76.76.76h8.51c.73,0,1.32.59,1.32,1.32v8.75c0,.73-.59,1.32-1.32,1.32-.03,0-.07,0-.1,0-.03,0-.06,0-.1,0-.42,0-.76.35-.76.76v2.81l-5.23-3.44s-.03-.02-.04-.02c-.03-.02-.06-.03-.09-.05-.02,0-.04-.02-.07-.02-.02,0-.05-.02-.08-.02-.03,0-.07,0-.09,0-.02,0-.04,0-.05,0h-10.4c-.73,0-1.32-.59-1.32-1.32v-4.92c0-.42-.35-.76-.76-.76s-.76.34-.76.76v4.92c0,1.57,1.27,2.84,2.84,2.84h10.19l6.22,4.1c.13.09.27.13.42.13.12,0,.25-.03.36-.09.25-.14.4-.39.4-.67v-3.51c1.3-.26,2.28-1.41,2.28-2.79v-8.75c0-1.58-1.27-2.85-2.84-2.85Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m101.64,70.08c0,.42.34.76.76.76h14.25c.42,0,.76-.34.76-.76s-.34-.76-.76-.76h-14.25c-.42,0-.76.34-.76.76Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m102.4,72.37c-.42,0-.76.34-.76.76s.34.76.76.76h6.37c.42,0,.76-.34.76-.76s-.34-.76-.76-.76h-6.37Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m116.65,67.8c.42,0,.76-.35.76-.76s-.34-.76-.76-.76h-4.18c-.42,0-.76.34-.76.76s.34.76.76.76h4.18Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.32,63.31c-.22,0-.41.08-.55.23s-.23.34-.23.56.08.4.23.55.33.23.55.23.4-.08.55-.23.23-.33.23-.55-.08-.41-.23-.56-.33-.23-.55-.23Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m95.28,59.46c.25,0,.48-.16.54-.39.05-.19.15-.35.28-.47.22-.21.53-.31.91-.31s.68.11.9.32.33.51.33.89c0,.52-.19.88-.55,1.06-.37.19-.9.28-1.59.28h-.36l.03,1.15c0,.3.26.54.55.54s.54-.23.55-.53v-.32c.77,0,1.37-.18,1.84-.55.45-.36.68-.9.68-1.63,0-.69-.22-1.24-.66-1.64-.44-.4-1.02-.6-1.75-.6-.48,0-.9.09-1.26.28-.36.19-.63.45-.83.78-.07.13-.13.26-.18.39-.12.37.16.76.54.76Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m136.79,37.38c-2.36-2.36-5.5-3.66-8.84-3.66s-6.48,1.3-8.84,3.66-3.66,5.5-3.66,8.84,1.3,6.48,3.66,8.84c2.36,2.36,5.5,3.66,8.84,3.66s6.48-1.3,8.84-3.66c2.36-2.36,3.66-5.5,3.66-8.84s-1.3-6.48-3.66-8.84Zm-19.96,8.84c0-1.39.26-2.72.73-3.95h4.5c-.2,1.26-.31,2.59-.31,3.95s.1,2.61.29,3.83h-4.52c-.44-1.19-.68-2.48-.68-3.83Zm6.3,0c0-1.37.11-2.71.33-3.95h3.8v7.78h-3.82c-.2-1.21-.3-2.5-.3-3.83Zm8.09-8.06c.38.81.69,1.73.94,2.72h-3.51v-5.65c.94.34,1.85,1.37,2.58,2.93Zm-3.96-2.93v5.65h-3.51c.24-.99.56-1.91.94-2.72.73-1.56,1.64-2.59,2.58-2.93Zm0,16.2v5.78c-.94-.34-1.85-1.37-2.58-2.93-.4-.85-.72-1.81-.97-2.85h3.55Zm1.39,5.78v-5.78h3.55c-.25,1.04-.57,2-.97,2.85-.73,1.56-1.64,2.59-2.58,2.93Zm0-7.16v-7.78h3.8c.21,1.25.33,2.58.33,3.95s-.1,2.62-.3,3.83h-3.82Zm5.2-7.78h4.5c.47,1.23.73,2.56.73,3.95s-.24,2.64-.68,3.83h-4.53c.19-1.22.29-2.51.29-3.83s-.1-2.7-.3-3.95Zm3.85-1.39h-4.12c-.28-1.2-.64-2.32-1.11-3.31-.35-.76-.75-1.42-1.18-1.96,2.75.87,5.04,2.78,6.41,5.27Zm-13.09-5.27c-.43.55-.83,1.2-1.18,1.96-.46.98-.83,2.1-1.11,3.31h-4.12c1.37-2.49,3.66-4.4,6.41-5.27Zm-6.48,15.82h4.16c.28,1.26.66,2.42,1.13,3.43.35.76.75,1.42,1.18,1.96-2.8-.88-5.12-2.84-6.48-5.4Zm13.16,5.4c.43-.55.83-1.2,1.18-1.96.47-1.02.86-2.18,1.13-3.43h4.17c-1.36,2.55-3.68,4.51-6.48,5.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.1f2505aa5893c44f259840b6a86547c6.svg";
export { ForwardRef as ReactComponent };